var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.408,
    height: 23.408,
    viewBox: "0 0 23.408 23.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(0 -0.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    transform: "translate(7.869 4.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    d: "M8.573,14.9l-.05-.575a4.7,4.7,0,0,1,1.561-3.835c1.137-1.174,1.761-2.049,1.761-3.048,0-1.124-.812-1.886-2.386-1.9a4.939,4.939,0,0,0-2.548.687L6.3,4.847A7.245,7.245,0,0,1,9.9,3.96c2.9,0,4.2,1.574,4.2,3.26,0,1.511-.949,2.586-2.173,3.86a4.083,4.083,0,0,0-1.436,3.26l.025.575H8.548Z",
    transform: "translate(-6.3 -3.959)",
    fill: "#92d4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    d: "M7.87,15.477a1.32,1.32,0,1,1,2.636-.137v.137a1.319,1.319,0,1,1-2.636.087v-.075Z",
    transform: "translate(-5.909 -1.435)",
    fill: "#92d4d0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    d: "M11.7,2.161A10.143,10.143,0,1,1,1.561,12.3h0A10.158,10.158,0,0,1,11.7,2.161M11.7.6a11.7,11.7,0,1,0,11.7,11.7h0A11.712,11.712,0,0,0,11.7.6Z",
    transform: "translate(0 0.184)",
    fill: "#92d4d0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.81271b6e924185019027e71c244f7f56.svg";
export { ForwardRef as ReactComponent };